import React from 'react';
import { View } from 'react-native';

import { useIsLargeScreen } from '@/hooks/use-is-large-screen';

export const Col: React.FC<{ children: React.ReactNode, size: number }> = ({ children, size }) => {
	const isLargeScreen = useIsLargeScreen();
	return <View
		style={
			isLargeScreen ?  {
				flex: size,
				gap: 16,
			} : {
				marginTop: 16,
			}
		}
	>
		{children}
	</View>;
};
